<template>
  <div id="giftCards">
    <Datatable
        id="giftCards"
        ref="datatable"
        entity="gift_card"
        :parameters="{branch: branchId}"
        :onRowClick="show"
        :globalActions="isDistributor ? [] : [
          {text: 'gift_card.new', method: newCard},
        ]"
        :rowActions="[{text: 'loyalty_transactions.show', method: show}]">
    </Datatable>

    <Modal class="new-gift-card-modal" name="new-gift-card-modal" :title="$t('gift_card.new_card')"
           :actions="[{name: $t('back'), action: 'close'}, {name: $t('confirm'), action: create}]">
      <div class="group">
        <label>{{$t('loyalty_transactions.amount')}} ($)</label>
        <input type="number" step="0.01" min="0" v-model="amount" placeholder="0.00">
      </div>
      <label>{{$t('gift_card.template_choice')}}</label>
      <div class="templates" v-if="templates && templates.length > 0">
        <div class="template" v-for="(template, templateIndex) of templates" :key="'template-' + templateIndex"
             :class="{selected: template.id === templateId}" @click="templateId = template.id">
          <div class="template-image" :style="{backgroundImage: 'url(\'' + getImage(template.image) + '\')'}"></div>
          <svgicon src="icon/check-circle-full.svg" :height="16" :width="16" class="check" v-if="template.id === templateId"></svgicon>
          <div class="template-name">{{$to(template.name)}}</div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="group">
            <label>{{$t('gift_card.from_name')}}</label>
            <input type="text" v-model="from.name">
          </div>
          <div class="group">
            <label>{{$t('gift_card.from_email')}}</label>
            <input type="text" v-model="from.email">
          </div>
        </div>
        <div class="column">
          <div class="group">
            <label>{{$t('gift_card.to_name')}}</label>
            <input type="text" v-model="to.name">
          </div>
          <div class="group">
            <label>{{$t('gift_card.to_email')}}</label>
            <input type="text" v-model="to.email">
          </div>
        </div>
      </div>
      <div class="group">
        <label>{{$t('gift_card.note')}}</label>
        <textarea v-model="from.note"></textarea>
      </div>
    </Modal>
  </div>
</template>

<script>
import Datatable from "@/components/Datatable.vue";
import {mapActions} from "vuex";

export default {
  name: "giftCards",

  components: { Datatable },

  data() {
    return {
      amount: null,
      templates: [],
      templateId: null,
      from: {
        name: "",
        email: "",
        note: ""
      },
      to: {
        name: "",
        email: ""
      },
    }
  },

  mounted() {
    this.$store.state.pageTitleTranslationKey = "gift_card.title";
    this.$store.state.pageIcon = "icon/gift.svg";
  },

  computed: {
    isDistributor() {
      return this.$store.state.loggedUser.isDistributor
    },
    branchId() {
      return this.$route.query.branch;
    }
  },

  methods: {
    ...mapActions(["createGiftCard", "loadGiftCardTemplates"]),

    show(row) {
      this.$router.push(this.$router.buildContext("/gift-card", {id: row.cardNumber}));
    },

    getImage(image) {
      if (!image || !image.url) {
        return;
      }
      return Parameters.urlFileServer + image.url;
    },

    async newCard() {
      showSpinner();
      await this.loadTemplates();
      hideSpinner();
      this.$modal.show("new-gift-card-modal");
    },

    async loadTemplates() {
      let response = await this.loadGiftCardTemplates(this.branchId);
      if (response) {
        console.log(response);
        this.templates = response.data.filter(t => t.active);
        if (this.templates.length > 0) {
          this.templateId = this.templates[0].id;
        }
      }
    },

    async create() {
      if (!this.amount || this.amount <= 0) {
        toast(this.$t('gift_card.amount_required'), "error");
        return;
      }
      let data = {
        amount: parseFloat(this.amount),
        processor: "manual",
        currency: "CAD",
        branch: this.branchId,
        to: this.to,
        from: this.from
      };
      showSpinner();
      let response = await this.createGiftCard(data);
      hideSpinner();
      if (response) {
        this.$modal.hide("new-gift-card-modal");
        toast(this.$t("success"), "success");
        this.$refs.datatable.query();
      } else {
        toast(this.$t("error.no_server"), "error");
      }
    }
  }
}
</script>

<style lang="scss">
  .new-gift-card-modal {
    .modalContainer {
      width: 700px !important;
    }

    .templates {
      display: flex;
      flex-wrap: wrap;
      margin-left: -8px;
      margin-right: -8px;
      margin-bottom: 5px;
      margin-top: 5px;

      .template {
        padding: 10px;
        text-align: center;
        font-size: 12px;
        color: #888;
        position: relative;
        cursor: pointer;
        &.selected {
          fill: #ed2937;
          .template-image {
            outline: 2px solid #ed2937;
          }
          .svgicon {
            border-radius: 100%;
            background-color: white;
            position: absolute;
            top: 12px;
            right: 12px;
          }
        }
        .template-name {
          margin-top: 5px;
        }
        .template-image {
          height: 70px;
          width: 100px;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          border-radius: 10px;
          border: 4px solid white;
          outline: 1px solid #ccc;
        }
      }
    }
  }
</style>
